import { toastr } from 'react-redux-toastr';
import * as Service from '../../server/RestClients';

export const GET_MODEL_DATA_LOADING = 'GET_MODEL_DATA_LOADING';
export const GET_MODEL_DATA_SUCCESS = 'GET_MODEL_DATA_SUCCESS';
export const GET_MODEL_DATA_FAILURE = 'GET_MODEL_DATA_FAILURE';

export const GET_SAMPLES_DATA_LOADING = 'GET_SAMPLES_DATA_LOADING';
export const GET_SAMPLES_DATA_SUCCESS = 'GET_SAMPLES_DATA_SUCCESS';
export const GET_SAMPLES_DATA_FAILURE = 'GET_SAMPLES_DATA_FAILURE';

export const DELETE_SAMPLE_LOADING = 'DELETE_SAMPLE_LOADING';
export const DELETE_SAMPLE_SUCCESS = 'DELETE_SAMPLE_SUCCESS';
export const DELETE_SAMPLE_FAILURE = 'DELETE_SAMPLE_FAILURE';

export const UPDATE_SAMPLE_LOADING = 'UPDATE_SAMPLE_LOADING';
export const UPDATE_SAMPLE_SUCCESS = 'UPDATE_SAMPLE_SUCCESS';
export const UPDATE_SAMPLE_FAILURE = 'UPDATE_SAMPLE_FAILURE';

export const getModelData = (config) => async (dispatch) => {
  dispatch({
    type: GET_MODEL_DATA_LOADING,
  });
  try {
    const modelDeployment = await Service.getModelDeployment(config);
    dispatch({
      type: GET_MODEL_DATA_SUCCESS,
      payload: modelDeployment,
    });
  } catch (e) {
    dispatch({
      type: GET_MODEL_DATA_FAILURE,
      payload: e,
    });
  }
};

export const clearSamplesData = () => async (dispatch) => {
  dispatch({
    type: GET_SAMPLES_DATA_SUCCESS,
    payload: {
      samplesPerLabel: undefined,
      totalSamples: undefined,
      totalLabels: undefined,
      allSamplesData: undefined,
    },
  });
};

export const getSamplesData = (config, req, flags) => async (dispatch) => {
  dispatch({
    type: GET_SAMPLES_DATA_LOADING,
  });
  try {
    const { rows: samplesList } = await Service.getSamples(config, req, flags);
    const samplesPerLabel = samplesList.reduce((acc, sample) => {
      const { label } = sample;
      if (acc[label]) {
        acc[label].push(sample);
      } else {
        acc[label] = [sample];
      }
      return acc;
    }, {});
    dispatch({
      type: GET_SAMPLES_DATA_SUCCESS,
      payload: {
        samplesPerLabel,
        totalSamples: samplesList.length,
        totalLabels: Object.keys(samplesPerLabel).length,
        allSamplesData: samplesList,
        flags,
      },
    });
  } catch (e) {
    dispatch({
      type: GET_SAMPLES_DATA_FAILURE,
      payload: e,
    });
  }
};

export const updateSamples =
  (config, samples, label, flags) => async (dispatch) => {
    dispatch({
      type: UPDATE_SAMPLE_LOADING,
    });
    try {
      await Service.updateSamples(config, samples, label, flags);
      dispatch({
        type: UPDATE_SAMPLE_SUCCESS,
      });
      dispatch(getSamplesData(config, {}, flags));
    } catch (e) {
      toastr.error('Failed to update samples', 'Please check your connection');
      dispatch({
        type: UPDATE_SAMPLE_FAILURE,
        payload: e,
      });
    }
  };

export const deleteSamples =
  (config, samplesIds, flags) => async (dispatch) => {
    dispatch({
      type: DELETE_SAMPLE_LOADING,
    });
    try {
      await Service.deleteSamples(config, samplesIds, flags);
      dispatch({
        type: DELETE_SAMPLE_SUCCESS,
      });
      dispatch(getSamplesData(config, {}, flags));
    } catch (e) {
      toastr.error('Failed to delete samples', 'Please check your connection');
      dispatch({
        type: DELETE_SAMPLE_FAILURE,
        payload: e,
      });
    }
  };
